module.exports = __webpack_public_path__ + "static/media/target.cf3a09df.png";